import {
  Box,
  BoxProps,
  ButtonNew as Button,
  ButtonProps,
  Image,
  ModalDialogNew,
  Spacer,
  Text,
  TextProps,
} from '@jfs/ui-new'
import { memo, useEffect } from 'react'
import { nativeJSComm, nativeJSMapper } from '../../util/WebFns'
import { BackHandler } from '../../util/backHandler'
import { SubTitle } from '../SubTitle'
import { Title } from '../Title'

interface ProgressDialogProps {
  show: boolean
  onDismiss?: any
  type: 'fingerprint' |'face'| 'loader' | 'error'
  error?: { code: any; error: string; title: string }
  onRetry?: any
  onCancel?: any
}

export const ProgressDialog = memo(({ show, onDismiss, type, error, onRetry, onCancel }: ProgressDialogProps) => {
  useEffect(() => {
    BackHandler.isTransactionLoaderShowing = show
  }, [show])

  if (!show) {
    return <></>
  }

  const onRetryPress = () => {
    if (error?.code === 7) {
      nativeJSComm(nativeJSMapper.installBiometricApp)
      onCancel()
    } else {
      onRetry(error?.code === 10 ? 'FACE' : 'FINGER_PRINT')
    }
  }

  return (
    <ModalDialogNew type={'bottom'} show={true} onDismiss={onDismiss} backgroundColor="TRANSPARENT">
      <Box {...styles.container}>
        <Image source={STATICDATA[type].imageScr} width={48} height={48} />
        <Spacer size={24} />
        <Title title={STATICDATA[type].title || error?.title} />
        <Spacer size={8} />
        <SubTitle subTitle={STATICDATA[type].subTitle || error?.error} />
        {error?.code && (
          <Box {...styles.buttonContainer}>
            <Button {...styles.secButton} onPress={onCancel} children={<Text {...styles.secText}>Cancel</Text>} />
            <Button {...styles.primaryButton} onPress={onRetryPress} title={error?.code == 7 ? 'Download' : 'Retry'} />
          </Box>
        )}
      </Box>
    </ModalDialogNew>
  )
})

const styles = {
  container: {
    flexDirection: 'column',
    pv: 48,
    ph: 24,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    alignItems: 'center',
    backgroundColor: 'WHITE',
  } as BoxProps,
  buttonContainer: {
    mt: 24,
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
  } as BoxProps,
  secButton: {
    type: 'secondaryFullWidth',
    width: '35vw',
    height: 48,
    borderRadius: 8,
    borderColor: 'PRIMARY',
  } as ButtonProps,
  secText: {
    color: 'PRIMARY',
    fontSize: 14,
    fontFamily: 'jioType-medium',
  } as TextProps,
  primaryButton: {
    type: 'primaryFullWidth',
    width: '35vw',
    color: 'PRIMARY',
    height: 48,
    borderRadius: 8,
    underlayColor: 'PRIMARY',
    hoverColor: 'PRIMARY',
  } as ButtonProps,
}

const STATICDATA = {
  fingerprint: {
    imageScr: require('../../assets/icons/ic_fingerprint_loader.gif'),
    title: 'Capturing Fingerprint…',
    subTitle: 'Please place your finger on the device',
  },
  face: {
    imageScr: require('../../assets/icons/ic_face_loader.gif'),
    title: 'Capturing Face…',
    subTitle: 'Face authentication in progress. Please hold still for a moment',
  },
  loader: {
    imageScr: require('../../assets/icons/ic_loader.gif'),
    title: 'Please wait...',
    subTitle: 'It is taking a bit longer than expected.',
  },
  error: {
    imageScr: require('../../assets/icons/ic_fingerprint_error.png'),
    title: '',
    subTitle: '',
  },
}
